<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
import { useI18n } from 'vue-i18n';
import { NavigationMenuLink } from 'reka-ui';

const { locale } = useI18n();
</script>

<template>
  <ul class="m-0 flex list-none gap-x-105 px-0 py-32 <lg:flex-col <lg:gap-32 <lg:py-16">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.project.content1.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.project.content1.item4.title')" to="/projects#graduation">
            <template #icon>
              <img data-src="@/assets/header/project-all-1.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content1.item1.title')" to="/projects#incubation">
            <template #icon>
              <img data-src="@/assets/header/project-all-2.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content1.item2.title')" to="/projects#preparatory">
            <template #icon>
              <img data-src="@/assets/header/project-all-3.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content1.item3.title')" to="/projects#archived">
            <template #icon>
              <img data-src="@/assets/header/project-all-4.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <li v-if="locale === 'zh-CN'">
      <ul class="flex flex-col list-none gap-y-32">
        <li class="flex flex-col gap-y-16">
          <div class="text-14 color-#A1A1A1 font-400 leading-17">专项社区</div>
          <ul class="m-0 w-331 list-none p-0">
            <li>
              <NavigationMenuLink href="https://power-iot.openatom.tech/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
                开放原子电力行业开源社区
              </NavigationMenuLink>
            </li>
            <li>
              <NavigationMenuLink href="https://xuanwu.openatom.cn/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
                开放原子旋武开源社区
              </NavigationMenuLink>
            </li>
          </ul>
        </li>
        <li class="flex flex-col gap-y-16">
          <div class="text-14 color-#A1A1A1 font-400 leading-17">服务平台</div>
          <ul class="m-0 w-331 list-none p-0">
            <li>
              <RouterLink to="/provided-services" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
                开放原子一站式服务平台
              </RouterLink>
            </li>
          </ul>
        </li>
        <li class="flex flex-col gap-y-16">
          <div class="text-14 color-#A1A1A1 font-400 leading-17">项目案例</div>
          <ul class="m-0 w-331 list-none p-0">
            <li>
              <RouterLink to="/case-study" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
                行业应用案例
              </RouterLink>
            </li>
          </ul>
        </li>
      </ul>
    </li>

    <!-- <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.project.content2.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.project.content2.item1.title')" :description="$t('header.project.content2.item1.desc')" href="https://www.openharmony.cn/">
            <template #icon>
              <img data-src="@/assets/header/project-star-1.png" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content2.item2.title')" :description="$t('header.project.content2.item2.desc')" href="https://www.openeuler.openatom.cn/">
            <template #icon>
              <img data-src="@/assets/header/project-star-2.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content2.item3.title')" :description="$t('header.project.content2.item3.desc')" href="https://www.openkylin.top/">
            <template #icon>
              <img data-src="@/assets/header/project-star-3.png" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content2.item4.title')" :description="$t('header.project.content2.item4.desc')" href="https://www.opentenbase.org/">
            <template #icon>
              <img data-src="@/assets/header/project-star-4.png" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
      </ul>
    </li> -->

    <ResourceTools />
  </ul>
</template>
